"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENT_TYPE_MORE_REFINEMENTS = exports.EVENT_TYPE_VIEW_CART = exports.EVENT_TYPE_HOME_PAGE_VIEW = exports.EVENT_TYPE_IMPRESSION = exports.EVENT_TYPE_ORDER = exports.EVENT_TYPE_REMOVE_FROM_CART = exports.EVENT_TYPE_ADD_TO_CART = exports.EVENT_TYPE_VIEW_PRODUCT = exports.EVENT_TYPE_AUTO_SEARCH = exports.EVENT_TYPE_SEARCH = void 0;
exports.EVENT_TYPE_SEARCH = 'search';
exports.EVENT_TYPE_AUTO_SEARCH = 'autoSearch';
exports.EVENT_TYPE_VIEW_PRODUCT = 'viewProduct';
exports.EVENT_TYPE_ADD_TO_CART = 'addToCart';
exports.EVENT_TYPE_REMOVE_FROM_CART = 'removeFromCart';
exports.EVENT_TYPE_ORDER = 'order';
exports.EVENT_TYPE_IMPRESSION = 'impression';
exports.EVENT_TYPE_HOME_PAGE_VIEW = 'homePageView';
// Deprecated event types.
exports.EVENT_TYPE_VIEW_CART = 'viewCart';
exports.EVENT_TYPE_MORE_REFINEMENTS = 'moreRefinements';
